const trimTrailingSlash = (value) => (value || '').replace(/\/$/, '');

export const DATA_URL = trimTrailingSlash(
  process.env.REACT_APP_DATA_URL || 'https://shashlichny-dom.ru/api'
);

export const API_URL = trimTrailingSlash(
  process.env.REACT_APP_API_URL || ''
);

export const dataFileUrl = (fileName) => `${DATA_URL}/${fileName}.json`;

export const saveFileUrl = (fileName) => `${API_URL}/api/save/${fileName}.json`;
